import { treatmentCategoriesApi } from '~/api';

const actionPrefix = (actionType) => `TreatmentCategories/${actionType}`;

export const SET_TREATMENT_CATEGORIES = actionPrefix`SET_TREATMENT_CATEGORIES`;

const setTreatmentCategories = (treatmentCategories) => ({
  type: SET_TREATMENT_CATEGORIES,
  payload: treatmentCategories,
});

const loadTreatmentCategories = () => (dispatch) =>
  treatmentCategoriesApi.get().then(({ treatmentCategories }) => {
    dispatch(setTreatmentCategories(treatmentCategories));
  });

export const treatmentCategoriesActions = {
  setTreatmentCategories,
  loadTreatmentCategories,
};
